import { ScheduleCalendarMode } from "../../../enums/schedule-calendar-mode.enum";
import { MonitorKey } from "../monitor-models/monitor-key.type";

export class ScheduleRequestParameters {

    public MonitorKeys: MonitorKey[];
    public ScheduleCalendarMode: ScheduleCalendarMode;

    constructor(keys: MonitorKey[], scheduleCalendarMode: ScheduleCalendarMode) {
        this.MonitorKeys = keys;
        this.ScheduleCalendarMode = scheduleCalendarMode;
    }

}